var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"dark":""}},[(_vm.title)?_c('v-card-title',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),(_vm.subtitle)?_c('v-card-subtitle',{staticClass:"subtitle",domProps:{"textContent":_vm._s(_vm.subtitle)}}):_vm._e(),_c('v-simple-table',{staticClass:"info-table"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }